module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "emmy-van-deurzen.4d8e36f7.jpg" + "?" + Date.now();